import React, { useEffect, useState } from "react";

const preloadImage = (src) => {
  const img = new Image();
  img.src = src;
  return img;
};

const TabletMobileSubNavigation = ({
  subnavdata,
  calloutdata,
  heading,
  subheading,
  designcheckbox,
  displaylink,
  displaytext,
  displaytitle,
}) => {
  const [navData, setNavData] = useState(subnavdata);
  const [level, setLevel] = useState(1);

  useEffect(() => {
    navData.forEach((navItem) => {
      window[navItem] = preloadImage(navItem.imagePath);
      navItem.subnavitemslist?.forEach((item) => (window[item] = preloadImage(item.navImagePath)));
    });
  }, [navData]);

  const handleClick = (navItems) => {
    const newNav = navItems.map((item) => {
      item.imagePath = item.navImagePath;
      item.buttonText = item.navTitle;
      return item;
    });
    setNavData(newNav);
    setLevel(2);
  };

  useEffect(() => {
    const handleBackAction = () => {
      setTimeout(() => {
        console.log("handle backnavigation --> ");
        setNavData(subnavdata);
        setLevel(1);
      }, 200);
    };

    const backButton = document.querySelector("span.header-back-btn");
    if (level === 2 && backButton) {
      backButton.addEventListener("click", handleBackAction);
    }

    return () => {
      backButton?.removeEventListener("click", handleBackAction);
    };
  }, [level]);

  return (
    <>
      <div className="banner">
        <div className="menu-hover">
          <nav className="header-nav">
            <ul
              className={`sub-navigation-level-${level}`}
              style={{ flexDirection: "column" }}
            >
              {navData.map((navItem, index) => (
                <li
                  key={`${level}-${index}`}
                  className="mob-header-list-li"
                  style={{
                    backgroundColor: navItem.isButton
                      ? "#bb0a0a"
                      : "#00000000",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (level === 2 || !navItem.subnavitemslist) {
                      window.location.href = `${
                        navItem.navPath || navItem.buttonLink
                      }`;
                    } else {
                      handleClick(navItem.subnavitemslist || []);
                    }
                  }}
                >
                  <>
                    <div className="li-title flex-column-center dark-title">
                      <img
                        src={navItem.imagePath}
                        alt="Resource Image"
                      ></img>
                      {navItem.buttonText}
                      <p>{navItem.imageMsrp}</p>
                    </div>
                    <span>
                      <i className="fa fa-regular fa-chevron-right"></i>
                    </span>
                  </>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        {calloutdata !== "null" &&
          calloutdata &&
          heading &&
          subheading &&
          level === 1 && (
            <div
              className="info-box"
              style={{ position: "unset", width: "100%" }}
            >
              <div className="title">{heading}</div>
              <div className="description">{subheading}</div>
              {calloutdata.map((btn) => (
                <div className="button-container" key={btn.buttonPath}>
                  <a
                    href={`${btn.buttonPath}.html`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button>{btn.buttonTitle}</button>
                  </a>
                </div>
              ))}
            </div>
          )}
      </div>
    </>
  );
};

export default TabletMobileSubNavigation;
